import { api } from '@/lib/api';
import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {
  CreateAgentParams,
  CreateAgentResponse,
  FetchAgentsParams,
  FetchAgentsResponse,
} from './types';

const _fetchAgents = async ({
  accountNumber,
}: FetchAgentsParams): Promise<AxiosResponse<FetchAgentsResponse>> => {
  return api.get(`1to1/agents?account_id=${accountNumber}`);
};
const useFetchAgents = (
  accountNumber?: FetchAgentsParams['accountNumber'],
  enabled?: boolean
) => {
  return useQuery({
    queryKey: ['fetch-agents', { accountNumber }],
    queryFn: () => _fetchAgents({ accountNumber: accountNumber! }),
    enabled: !!accountNumber && (!!enabled || typeof enabled === 'undefined'),
    retry: 0,
  });
};

const _createAgent = async ({
  account_id,
  email,
  first_name,
  last_name,
  password,
}: CreateAgentParams): Promise<AxiosResponse<CreateAgentResponse>> => {
  return api.post('v2/p2p/agents', {
    account_id,
    email,
    first_name,
    last_name,
    password,
  });
};
const useCreateAgent = () => {
  return useMutation({
    mutationFn: _createAgent,
  });
};

export { useCreateAgent, useFetchAgents };
